// removed by extract-text-webpack-plugin
module.exports = {"container":"_25Qd","wrapper":"_1vEU","textContainer":"_1JXk","description":"_2IVN","title":"_5gjv","list":"_3hQ2","listItem":"o4A7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/JobDescription/PreviousExperiences/styles.scss
// module id = 499
// module chunks = 0